import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'test',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/test.vue'),
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/main',
    name: 'home',
    component: HomeView,
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/car',
    name: 'car',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CarView.vue'),
    meta:{
      keepAlive:false
    }
  },
  {
    path: '/recovery',
    name: 'recovery',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Dayrecovery.vue'),
    meta:{
      keepAlive:false
    }
  },
  {
    path: '/cumulative',
    name: 'cumulative',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Cumulativerecovery.vue'),
    meta:{
      keepAlive:false
    }
  },
  {
    path: '/watch',
    name: 'watch',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/watch.vue'),
    meta:{
      keepAlive:false
    }
  },
  
  {
    path: '/dispose',
    name: 'test',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/dispose.vue'),
    meta:{
      keepAlive:false
    }
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if(to.path=='/'){
    routes[1].meta.keepAlive=false
    next()
  }else{
    routes[1].meta.keepAlive=true
    next()
  }
});

export default router
